import React, { CSSProperties } from "react";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";

export const FormElementWrapper: React.FC<React.PropsWithChildren<{ height: number }>> = props => {
  const styles = css`
    position: relative;

    --b: 1px;
    --c: 1px;

    height: var(--h);
    border-width: var(--b);
    border-style: solid;
    border-color: ${CSS_COLORS.Grey4};

    outline-width: var(--c);
    outline-style: solid;
    outline-color: transparent;

    border-radius: 6px;

    display: flex;
    align-items: center;

    &:focus-within {
      outline-color: ${CSS_COLORS.Green};
      border-width: calc(var(--b));
      border-color: ${CSS_COLORS.Green};

      box-shadow: 0 0 10px 0 rgba(31, 112, 87, 0.5);
    }
  `;

  return (
    <div
      style={
        {
          "--h": `${props.height}px`,
        } as CSSProperties
      }
      css={styles}
    >
      {props.children}
    </div>
  );
};
